import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { createRef, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { formatColor } from './PremioGeral';

const thStyle = { border: '1px solid #ccc', padding: '6px 8px', textAlign: 'left', backgroundColor: '#f1f1f1', fontSize: '0.85rem' };
const tdStyle = { border: '1px solid #ccc', padding: '6px 8px', fontSize: '0.85rem' };

export function PremioTurma({ data, producaoTotal, producaoTurmas, ocultarNomes, initialDate, finalDate }) {
    const [index, setIndex] = useState(0);
    const [turmas, setTurmas] = useState([]);

    function format(rowData, props) {
        if (rowData[props.field] === undefined) {
            return ""
        }
        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData[props.field]) + "%";
    }

    const indexRef = useRef(0);
    const handlePrintNormal = useReactToPrint({
        content: () => turmas[indexRef.current] ? turmas[indexRef.current].ref.current : null
    });

    const handlePrintAssinatura = useReactToPrint({
        content: () => turmas[indexRef.current] ? turmas[indexRef.current].printRef.current : null,
        pageStyle: `
            @page { size: landscape; margin: 12mm; }
            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
        `
    });

    useEffect(() => {
        if (!data) return;
        let items = data.filter((element) => {
            return element.tipo !== '1' && element.tipo !== '4';
        });
        items = items.sort(function (a, b) {
            if (a.turma > b.turma) {
                return 1;
            } else {
                return -1;
            }
        });
        let turmas = [];
        items.forEach((item) => {
            let index = turmas.findIndex(element => {
                return element.turma === item.turma;
            });
            if (index === -1) {
                turmas.push({
                    turma: item.turma,
                    values: [],
                    ref: createRef(),
                    printRef: createRef()
                });
            }
        });
        turmas.forEach((element, index) => {
            turmas[index].values = items
                .filter(item => item.turma === element.turma)
                .sort((a, b) =>
                    String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR', { sensitivity: 'base' })
                );
        });
        setTurmas(turmas);
    }, [data]);

    const calcQualidade = (rowData) => {
        const prodGeral = Number(producaoTotal) || 0;
        const defeito = Number(rowData.metragem) || 0;

        if (prodGeral === 0 || defeito === 0) return "0,00%";

        const porcentagem = (defeito / prodGeral) * 100;
        return porcentagem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "%";
    };

    const formatPeriodo = () => {
        if (!initialDate || !finalDate) return "";
        const fmt = (d) => new Date(d).toLocaleDateString('pt-BR');
        return `${fmt(initialDate)} a ${fmt(finalDate)}`;
    };

    return (
        <div>
            {turmas.length > 0 && turmas.map((turma, index) => {
                const totalDefeitoTurma = (() => {
                    const primeiraTurma = turma.values?.find(item => item.tipof === "Turma");
                    return Number(String(primeiraTurma?.metragem || 0).replace('m', '').replace(',', '.'));
                })();
                const totalProducaoTurma = producaoTurmas
                    ? producaoTurmas
                        .filter(pt => {
                            const mapaTurmas = { 'A': 1, 'B': 2, 'C': 3, 'D': 4 };
                            const idBuscado = mapaTurmas[turma.turma] || turma.turma;
                            return String(pt.turma_id) === String(idBuscado);
                        })
                        .reduce((acc, pt) => acc + Number(pt.total_metros || 0), 0)
                    : 0;

                return (
                    <div key={index} className="p-mb-5">
                        <Button
                            className="p-m-1"
                            icon="pi pi-print"
                            tooltip="Imprimir relatório"
                            onClick={() => {
                                indexRef.current = index;
                                setIndex(index);
                                handlePrintNormal();
                            }}
                        />
                        <Button
                            className="p-m-1 p-button-secondary"
                            icon="pi pi-file"
                            label="Assinatura"
                            tooltip="Imprimir para assinatura"
                            onClick={() => {
                                indexRef.current = index;
                                setIndex(index);
                                handlePrintAssinatura();
                            }}
                        />
                        <div ref={turma.ref}>
                            <h3>Turma {turma.turma}</h3>
                            <p style={{ marginTop: '-10px', fontWeight: '600' }}>
                                Total Metragem Defeito: <span style={{ color: '#7a0000', fontWeight: 700 }}>{totalDefeitoTurma.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m</span>
                            </p>
                            <p style={{ marginTop: '-10px', fontWeight: '600' }}>
                                Total Metragem Produzida: <span style={{ color: '#00397a', fontWeight: 700 }}>{totalProducaoTurma.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m</span>
                            </p>
                            <DataTable
                                className="p-mb-3"
                                emptyMessage="Nenhum registro encontrado."
                                key={index}
                                rowHover
                                stripedRows
                                size="small"
                                value={turma.values}
                            >
                                {!ocultarNomes && (
                                    <Column header="Colaborador" field="nome" sortable style={{ minWidth: "200px", width: "20%" }} />
                                )}
                                <Column header="Turma" field="turma" sortable />
                                <Column header="Grupo" field="grupo" sortable />
                                <Column header="Tipo" field="tipof" sortable />
                                <Column header="Metragem" field="metragem" sortable body={(r) => Number(r.metragem).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "m"} />
                                <Column header="Qualidade" body={calcQualidade} style={{ fontWeight: 'bold' }} />
                                <Column header="Prêmio de Qualidade" field="premio" sortable body={(rowData) => formatColor(rowData, 'premio')} />
                                <Column header="Eficiência" field="eficiencia" sortable body={format} />
                                <Column header="Prêmio de Eficiência" field="premio_eficiencia" sortable body={(rowData) => formatColor(rowData, 'premio_eficiencia')} />
                            </DataTable>
                        </div>

                        {/* Template de impressão oculto na tela, usado só pelo handlePrint */}
                        <div style={{ display: 'none' }}>
                            <div ref={turma.printRef} style={{ padding: '10px', fontFamily: 'Arial, sans-serif', color: '#000' }}>
                                <h2 style={{ marginBottom: '4px' }}>Prêmio de Qualidade e Produção — Turma {turma.turma}</h2>
                                <p style={{ margin: '2px 0' }}><strong>Período:</strong> {formatPeriodo()}</p>
                                <p style={{ margin: '2px 0' }}>
                                    <strong>Total Metragem de Defeito da Turma:</strong>{' '}
                                    <span style={{ color: '#7a0000', fontWeight: 700 }}>
                                        {totalDefeitoTurma.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m
                                    </span>
                                </p>

                                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '14px' }}>
                                    <thead>
                                        <tr>
                                            {!ocultarNomes && <th style={thStyle}>Nome</th>}
                                            <th style={thStyle}>Metros Defeito</th>
                                            <th style={thStyle}>Prêmio Qualidade</th>
                                            <th style={thStyle}>Eficiência</th>
                                            <th style={thStyle}>Prêmio Produção</th>
                                            <th style={thStyle}>Prêmio Total</th>
                                            <th style={thStyle}>Assinatura</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {turma.values?.map((rowData, i) => (
                                            <tr key={i}>
                                                {!ocultarNomes && <td style={tdStyle}>{rowData.nome}</td>}
                                                <td style={tdStyle}>{Number(rowData.metragem).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m</td>
                                                <td style={tdStyle}>{formatColor(rowData, 'premio')}</td>
                                                <td style={tdStyle}>{format(rowData, { field: 'eficiencia' })}</td>
                                                <td style={tdStyle}>{formatColor(rowData, 'premio_eficiencia')}</td>
                                                <td style={tdStyle}>{formatColor({...rowData, premio_total: Number(rowData.premio || 0) + Number(rowData.premio_eficiencia || 0)}, 'premio_total' )}</td>
                                                <td style={{ ...tdStyle, minWidth: '140px' }}>
                                                    <div style={{ borderBottom: '1px solid #000', height: '22px' }}></div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    )
}